// Find the element closest to the click/touch position using distance to edge of element.
function getNearestElement<ElementType extends Element>(
  event: MouseEvent | TouchEvent,
  elements: NodeListOf<ElementType>,
) {
  if (elements.length <= 1) return elements[0];

  const clientX =
    'clientX' in event ? event.clientX : event.touches[0]?.clientX;
  const clientY =
    'clientY' in event ? event.clientY : event.touches[0]?.clientY;

  if (!clientX || !clientY) return elements[0];

  let closest = Infinity;
  let closestEl = elements[0];

  for (const element of elements) {
    const { left, right, top, bottom } = element.getBoundingClientRect();

    // Calculate distance to nearest edge
    // If click is inside the element, distance is 0
    const distanceX = Math.max(0, left - clientX, clientX - right);
    const distanceY = Math.max(0, top - clientY, clientY - bottom);
    const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

    if (distance < closest) {
      closest = distance;
      closestEl = element;
    }
  }

  return closestEl;
}

export { getNearestElement };
